import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UnitService } from 'src/app/services/unit.service';
import { environment } from 'src/environments/environment';
import Lightbox from 'bs5-lightbox';

@Component({
  selector: 'app-list-checklist-unit',
  templateUrl: './list-checklist-unit.component.html',
  styleUrls: ['./list-checklist-unit.component.css']
})
export class ListChecklistUnitComponent implements OnInit {
  data: any[] = [];
  openStates: boolean[] = [];
  url_path = environment.url_page;
  private unitId: any;

  constructor(private apiUnit: UnitService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.unitId = this.route.snapshot.params["id"];
    this.apiUnit.getChecklist(this.unitId).subscribe((res: any) => {
      this.data = res;
      this.openStates = new Array(res.length).fill(false);
      setTimeout(() => {
        this.initializeLightbox();
      }, 200);
    });
  }

  toggleOpen(i: number): void {
    this.openStates[i] = !this.openStates[i];
  }

  goCreateChecklist(): void {
    const unitData = this.data[0]?.unit ?? { id: this.unitId };
    this.router.navigate(['/unit/checklist'], { state: { data: unitData } });
  }

  private initializeLightbox(): void {
    document.querySelectorAll('[data-toggle="lightbox"]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        new Lightbox(el as HTMLElement).show();
      });
    });
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const parts = dateStr.split('-');
    if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
    return dateStr;
  }

  getTiresArray(tiresData: any): any[] {
    try {
      if (!tiresData) return [];
      if (Array.isArray(tiresData)) return tiresData;
      return JSON.parse(tiresData);
    } catch (error) {
      return [];
    }
  }
}
